module.exports = __webpack_public_path__ + "img/remove-user.3edb45e3.png";